import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { FilterContextProvider } from "./context/FilterContext";
import { GetDataContextProvider } from "./context/GetDataContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  /*    NOTE: React.StrictMode is only for development stage
       https://reactjs.org/docs/strict-mode.html
       https://stackoverflow.com/questions/61254372/my-react-component-is-rendering-twice-because-of-strict-mode
       */
  // <React.StrictMode>
  <GetDataContextProvider>
    <FilterContextProvider>
      <App />
    </FilterContextProvider>
  </GetDataContextProvider>

  // </React.StrictMode>
);
